import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './hero.module.scss'

interface IHeroProps {
  type: 'logos' | 'office' | 'products' | 'people'
}

export default function Hero({ type }: IHeroProps) {
  const enums = {
    logos: <FormattedMessage defaultMessage="Logotyper" id="assets.hero-logos.heading" />,
    office: <FormattedMessage defaultMessage="Kontor" id="assets.hero-office.heading" />,
    products: <FormattedMessage defaultMessage="Produkter" id="assets.hero-products.heading" />,
    people: <FormattedMessage defaultMessage="Vår VD Sam Nurmi" id="assets.hero-people.heading" />,
  }

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <h1 className={styles.heading}>{enums[type]}</h1>
        </div>
      </div>
    </div>
  )
}
